















import SearchBuilder from '@/components/search/SearchBuilder.vue';
import MStoreSavedSearches from '@/components/shared/MStoreSavedSearches.vue';
import { SearchCriteriaModel, StoreConstants } from '@/types';
import { Search } from '@/types/constants/routes/search';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SearchCriteria',
  data() {
    return {
      activeTab: 0
    };
  },
  computed: {
    ...mapGetters(StoreConstants.Search.ModuleName, [StoreConstants.Search.Getters.SearchCriteria]),
    ...mapGetters(StoreConstants.UserPreferences.ModuleName, [StoreConstants.UserPreferences.Getters.SearchOptions]),
    ...mapGetters(StoreConstants.Oidc.ModuleName, [StoreConstants.Oidc.Getters.OidcUser]),
    searchCriteriaModel(this: any): SearchCriteriaModel {
      if (this[StoreConstants.Search.Getters.SearchCriteria]?.cabinets?.length && this[StoreConstants.Search.Getters.SearchCriteria].userId === this[StoreConstants.Oidc.Getters.OidcUser].id) {
        return this[StoreConstants.Search.Getters.SearchCriteria];
      }

      if (this[StoreConstants.UserPreferences.Getters.SearchOptions]?.cabinets?.length) {
        return this[StoreConstants.UserPreferences.Getters.SearchOptions];
      }

      return {} as SearchCriteriaModel;
    }
  },
  methods: {
    ...mapActions(StoreConstants.Search.ModuleName, [StoreConstants.Search.Actions.SetSearchCriteria]),
    ...mapActions(StoreConstants.ApplicationDirty.ModuleName, [StoreConstants.ApplicationDirty.Actions.ResetApplicationDirtyState]),
    search(this: any, searchCriteria: SearchCriteriaModel) {
      this[StoreConstants.Search.Actions.SetSearchCriteria]({ ...searchCriteria });
      this[StoreConstants.ApplicationDirty.Actions.ResetApplicationDirtyState]();
      this.$router.push({ name: Search.Results.name });
    },
    setActiveTab(this: any, tabNumber: number) {
      this.activeTab = tabNumber;
    }
  },
  components: { SearchBuilder, MStoreSavedSearches }
});
